import { initialState, UPDATE_FORM } from '../../model/forms.model';

export function formReducer(
  state: any = initialState,
  action: { type: string; payload: any }
) {
  switch (action.type) {
    case UPDATE_FORM:
      return Object.assign({}, state, {
        [action.payload.path]: action.payload.value
      });
    default:
      return state;
  }
}
